import React from 'react';
import { buildPlanLimitRows, isFreeLikePlan } from '../../utils/planCatalogUtils';

/**
 * Shared Plan limits panel — status API / plans API fields only (no invented caps).
 */
export default function PlanLimitsPanel({ subscription, className = '' }) {
  if (!subscription) return null;

  const rows = buildPlanLimitRows(subscription, { paidUnlimited: true });
  const freeLike = isFreeLikePlan(
    subscription.plan_name || subscription.name,
    subscription.plan_type,
    subscription.is_free_trial
  );
  const hasAnyCap = rows.some(
    (r) => r.value && r.value !== 'Unlimited' && r.value !== 'Not set' && r.value !== 'Any allowed'
  );
  if (!freeLike && !hasAnyCap) return null;

  return (
    <section
      className={`rounded-2xl border border-slate-200 bg-white px-4 py-4 shadow-sm ${className}`}
    >
      <header className="mb-3">
        <p className="text-xs font-semibold uppercase tracking-wider text-indigo-500">
          Plan limits
        </p>
        <p className="text-sm text-slate-500 mt-0.5">
          From your subscription entitlements (Community / plan caps)
        </p>
      </header>
      <dl className="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-2">
        {rows.map((row) => (
          <div
            key={row.label}
            className="flex items-baseline justify-between gap-2 border-b border-slate-100 py-1.5 last:border-0"
          >
            <dt className="text-xs font-medium text-slate-500" title={row.hint}>
              {row.label}
            </dt>
            <dd className="text-sm font-semibold text-slate-800 tabular-nums text-right">
              {row.value}
            </dd>
          </div>
        ))}
      </dl>
    </section>
  );
}
